export default "__VITE_ASSET__V6KHDxW5__"